import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@/shared/components/atoms';

const Header = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string | ReactNode;
}) => {
  const { t } = useTranslation('common');
  return (
    <div className='mb-32'>
      <Typography variant='h1' weight='bold'>
        {t(title)}
      </Typography>
      {subtitle && typeof subtitle === 'string' ? (
        <Typography className='text-surface-10' variant='subtitle2'>
          {t(subtitle)}
        </Typography>
      ) : (
        subtitle ?? ''
      )}
    </div>
  );
};
export default Header;
